export function extractYearsExperienceCount(value) {
  const raw = String(value ?? "").trim();
  if (!raw || raw === "—") return null;

  const match = raw.match(/(\d+(?:[.,]\d+)?)/);
  if (!match) return null;

  const numeric = Number(match[1].replace(",", "."));
  return Number.isFinite(numeric) ? numeric : null;
}

export function formatYearsExperienceLabel(
  value,
  t = (_, fallback) => fallback,
  fallback = "—",
) {
  const raw = String(value ?? "").trim();
  if (!raw || raw === "—") return fallback;

  const count = extractYearsExperienceCount(raw);
  if (count == null) return raw;

  const displayCount = Number.isInteger(count) ? String(count) : String(count);
  return t("appointments.common.yearsExperience", "{count} years", {
    count: displayCount,
  });
}
